<div class="action-button-container">
  <button
    zagButton="outlined"
    zagType="secondary"
    zagSize="sm"
    type="button"
    [attr.aria-label]="label()"
    [attr.aria-expanded]="dropdownOpen()"
    (click)="toggleDropdown($event)"
  >
    @if (currentOption) {
      @if (currentOption.icon) {
        <span [zagIcon]="currentOption.icon"></span>
      } @else if (currentOption.displayText !== undefined) {
        <span class="display-text">{{ currentOption.displayText }}</span>
      }
    }
    <span zagIcon="expand-more" zagEnd></span>
  </button>

  <div class="dropdown-menu" role="menu" [class.dropdown-visible]="dropdownOpen()">
    @if (dropdownTitle()) {
      <div class="dropdown-header">{{ dropdownTitle() | translate }}</div>
    }
    @for (option of options(); track option.id) {
      <button
        zagButton
        zagType="secondary"
        zagSize="sm"
        type="button"
        class="dropdown-item"
        [class.active]="option.id === currentValue()"
        role="menuitem"
        (click)="selectOption(option.id, $event)"
      >
        @if (option.icon) {
          <span [zagIcon]="option.icon"></span>
        }
        <span class="option-label">{{ option.label | translate }}</span>
        @if (option.id === currentValue()) {
          <span zagIcon="check" zagEnd class="check-icon"></span>
        }
      </button>
    }
  </div>
</div>
